export default __webpack_public_path__ + "static/media/Series-8800-MP-Insertion.a9fcf943.png";